<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
          <el-breadcrumb-item>收款音箱</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">
          <el-form-item >
            <el-input  placeholder="店铺名称" v-model="queryParam.name" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="Search" size="small" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="rows" style="width: 100%">
          <el-table-column  prop="StoreName" :show-overflow-tooltip="true" label="所属店铺"> </el-table-column>
          <el-table-column  prop="DeviceName"  :show-overflow-tooltip="true"  label="Id"> </el-table-column>
          <el-table-column  prop="CreateTime"  width="120px" label="创建时间" :formatter="dateFormat"> </el-table-column>
          <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="Edit(scope.row)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>    
    <dia v-bind:dialog="dialog" @GetData="GetData"></dia>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import dia from './info'
  export default {
    props:{
    },
    data (){
      return {        
        rows:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' CreateTime desc',
        },
        dialog: {
          isShow:false,
          id:0,
          storeName:'',
          storeId:0,
          deviceName:'',
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Hardware/SpeakerIndex',
          params: this.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      Edit(row){
        this.dialog.id = row.Id
        this.dialog.storeName = row.StoreName
        this.dialog.deviceName = row.DeviceName
        this.dialog.storeId = row.ChainStoreId
        this.dialog.isShow = true
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      }
    },
    components:{    
      dia
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px   

</style>